import React from 'react';
import {datePersianFormat} from 'helpers/Functions';
import {Grid} from '@mui/material';

const ListDateTitle = (props) => {
  const {page, index} = props;
  let showTitle = true;
  let title = '';
  if (index !== 0) {
    //if date of item is equal to date of item that is before it =>do not show date title
    if (
      page[index].jalaliDate.split(/\s+/)[0] ===
      page[index - 1].jalaliDate.split(/\s+/)[0]
    ) {
      showTitle = false;
    } else {
      title = datePersianFormat(page[index].jalaliDate);
    }
  } else {
    title = datePersianFormat(page[index].jalaliDate);
  }

  return (
    <Grid
      item
      xs={12}
      display='grid'
      justifyContent='center'
      alignItems='center'
      pt={'10px'}>
      <p
        style={{
          display: showTitle ? 'grid' : 'none',
          margin: index === 0 ? '0px 5px 20px' : '30px 5px 20px',
          fontSize: '18px',

          fontFamily: 'dana-bold',
          color: '#753cbe',
          letterSpacing: '0.8px',
        }}>
        {title}
      </p>
    </Grid>
  );
};
export default ListDateTitle;
